import { AssetTypeDto } from './models';

export class AssetTypeDtoEmpty implements AssetTypeDto{
  name = '';
}